import { render } from "./TrimsTable.vue?vue&type=template&id=194ad53b&scoped=true"
import script from "./TrimsTable.vue?vue&type=script&lang=js"
export * from "./TrimsTable.vue?vue&type=script&lang=js"

import "./TrimsTable.vue?vue&type=style&index=0&id=194ad53b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-194ad53b"]])

export default __exports__